/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

/* Desktop Tab Change */

const jsHeaderTab_Main = document.getElementById("jsHeaderTab_Main");
const jsHeaderTab_Golf = document.getElementById("jsHeaderTab_Golf");

if (jsHeaderTab_Main) {
  jsHeaderTab_Main.addEventListener("click", function () {
    localStorage.setItem("header", "main");
    window.location.href = "https://zerohalliburton.jp";
  });
}

if (jsHeaderTab_Golf) {
  jsHeaderTab_Golf.addEventListener("click", function () {
    localStorage.setItem("header", "golf");
    window.location.href = "https://zerohalliburton.jp/pages/golf-top";
  });
}

function updateHeader() {
  const header = localStorage.getItem("header");
  const jsLogo_Main = document.getElementById("jsLogo_Main");
  const jsLogo_Golf = document.getElementById("jsLogo_Golf");
  const jsDesktopMenu_Main = document.getElementById("jsDesktopMenu_Main");
  const jsDesktopMenu_Golf = document.getElementById("jsDesktopMenu_Golf");
  const jsMobileMenu_Main = document.getElementById("jsMobileMenu_Main");
  const jsMobileMenu_Golf = document.getElementById("jsMobileMenu_Golf");
  const jsAnnouncementBar_Main = document.getElementById("jsAnnouncementBar_Main");
  const jsAnnouncementBar_Golf = document.getElementById("jsAnnouncementBar_Golf");

  if (header === "golf") {
    if (jsLogo_Main) jsLogo_Main.style.display = "none";
    if (jsLogo_Golf) jsLogo_Golf.style.display = "block";
    if (jsDesktopMenu_Main) jsDesktopMenu_Main.style.display = "none";
    if (jsDesktopMenu_Golf) jsDesktopMenu_Golf.style.display = "block";
    if (jsMobileMenu_Main) jsMobileMenu_Main.style.display = "none";
    if (jsMobileMenu_Golf) jsMobileMenu_Golf.style.display = "block";
    if (jsHeaderTab_Main) jsHeaderTab_Main.classList.remove("is-active");
    if (jsHeaderTab_Golf) {
      jsHeaderTab_Golf.classList.add("is-active");
      jsHeaderTab_Golf.disabled = true;
    }
    if (jsAnnouncementBar_Main) jsAnnouncementBar_Main.style.display = "none";
    if (jsAnnouncementBar_Golf) jsAnnouncementBar_Golf.style.display = "flex";
  } else {
    if (jsLogo_Main) jsLogo_Main.style.display = "block";
    if (jsLogo_Golf) jsLogo_Golf.style.display = "none";
    if (jsDesktopMenu_Main) jsDesktopMenu_Main.style.display = "block";
    if (jsDesktopMenu_Golf) jsDesktopMenu_Golf.style.display = "none";
    if (jsMobileMenu_Main) jsMobileMenu_Main.style.display = "block";
    if (jsMobileMenu_Golf) jsMobileMenu_Golf.style.display = "none";
    if (jsHeaderTab_Main) {
      jsHeaderTab_Main.classList.add("is-active");
      jsHeaderTab_Main.disabled = true;
    }
    if (jsHeaderTab_Golf) jsHeaderTab_Golf.classList.remove("is-active");
    if (jsAnnouncementBar_Main) jsAnnouncementBar_Main.style.display = "flex";
    if (jsAnnouncementBar_Golf) jsAnnouncementBar_Golf.style.display = "none";
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const currentUrl = window.location.href;
  if (currentUrl === "https://zerohalliburton.jp/") {
    localStorage.setItem("header", "main");
  } else if (currentUrl === "https://zerohalliburton.jp/pages/golf-top") {
    localStorage.setItem("header", "golf");
  }
  updateHeader();
});

// document.addEventListener('DOMContentLoaded', updateHeader);

/* Mobile Tab Change */

const jsMobileNavTab_Main = document.getElementById("jsMobileNavTab_Main");
const jsMobileNavTab_Golf = document.getElementById("jsMobileNavTab_Golf");

if (jsMobileNavTab_Main) {
  jsMobileNavTab_Main.addEventListener("click", function () {
    localStorage.setItem("header", "main");
    updateMobileMenu();
  });
}

if (jsMobileNavTab_Golf) {
  jsMobileNavTab_Golf.addEventListener("click", function () {
    localStorage.setItem("header", "golf");
    updateMobileMenu();
  });
}

function updateMobileMenu() {
  const header = localStorage.getItem("header");
  const jsMobileNavTab_Main = document.getElementById("jsMobileNavTab_Main");
  const jsMobileNavTab_Golf = document.getElementById("jsMobileNavTab_Golf");
  const jsMobileMenu_Main = document.getElementById("jsMobileMenu_Main");
  const jsMobileMenu_Golf = document.getElementById("jsMobileMenu_Golf");

  if (header === "golf") {
    if (jsMobileNavTab_Main) {
      jsMobileNavTab_Main.classList.remove("is-active");
      jsMobileNavTab_Main.disabled = false;
    }
    if (jsMobileNavTab_Golf) {
      jsMobileNavTab_Golf.classList.add("is-active");
      jsMobileNavTab_Golf.disabled = true;
    }
    if (jsMobileMenu_Main) jsMobileMenu_Main.style.display = "none";
    if (jsMobileMenu_Golf) jsMobileMenu_Golf.style.display = "block";
  } else {
    if (jsMobileNavTab_Main) {
      jsMobileNavTab_Main.classList.add("is-active");
      jsMobileNavTab_Main.disabled = true;
    }
    if (jsMobileNavTab_Golf) {
      jsMobileNavTab_Golf.classList.remove("is-active");
      jsMobileNavTab_Golf.disabled = false;
    }
    if (jsMobileMenu_Main) jsMobileMenu_Main.style.display = "block";
    if (jsMobileMenu_Golf) jsMobileMenu_Golf.style.display = "none";
  }
}

document.addEventListener("DOMContentLoaded", updateMobileMenu);

/* タブ切り替え Airline Guide */
const select = document.getElementById("airline-select");
const tabs = document.getElementById("guide-tabs");

// 要素が存在する場合のみイベントリスナーを追加
if (select && tabs) {
  // タブ切り替え関数
  function switchTab(targetTab) {
    // タブボタンのアクティブ状態を更新
    const tabButtons = document.querySelectorAll(".c-tab-button");
    const targetButton = document.querySelector(`[data-tab="${targetTab}"]`);
    const targetContent = document.getElementById(targetTab);

    if (tabButtons.length > 0 && targetButton && targetContent) {
      tabButtons.forEach((btn) => btn.classList.remove("active"));
      targetButton.classList.add("active");

      // タブコンテンツの表示/非表示を切り替え
      document.querySelectorAll(".c-tab-content").forEach((el) => el.classList.add("is-hidden"));
      targetContent.classList.remove("is-hidden");
    }
  }

  select.addEventListener("change", function () {
    const selectedId = this.value;

    if (selectedId) {
      // すべてのガイドコンテンツを非表示
      const guideContents = document.querySelectorAll(".guide-content");
      if (guideContents.length > 0) {
        guideContents.forEach((el) => {
          el.classList.add("is-hidden");
        });
      }

      // 選択されたガイドのコンテンツのみ表示
      const selectedContent = document.querySelectorAll(`[data-guide-id="${selectedId}"]`);

      if (selectedContent.length > 0) {
        selectedContent.forEach((el) => {
          el.classList.remove("is-hidden");
        });
      }

      // ガイドタブを表示
      tabs.classList.remove("is-hidden");

      // 機内持ち込みタブをアクティブにして、そのコンテンツを表示
      switchTab("carry-on");
    } else {
      tabs.classList.add("is-hidden");
    }
  });

  // タブボタンのクリックイベント
  document.addEventListener("click", function (event) {
    if (event.target.classList.contains("c-tab-button")) {
      const target = event.target.dataset.tab;
      if (target) {
        switchTab(target);
      }
    }
  });
}

/* ============ 在庫管理モーダル ============ */
class CStockModal {
  constructor() {
    this.modal = null;
    this.overlay = null;
    this.closeButton = null;
    this.productTitle = null;
    this.tableBody = null;
    this.init();
  }

  init() {
    // モーダル要素を作成
    this.createModal();

    // イベントリスナーを設定
    this.setupEventListeners();

    // 商品カードのカラースウォッチクリックイベントを監視
    this.setupColorSwatchListeners();

    // 初期表示時の在庫状況テキストを設定
    this.initializeModalTexts();

    // 動的に追加された商品カードの監視
    this.setupMutationObserver();
  }

  initializeModalTexts() {
    // 各商品カードのモーダルテキストに商品全体の在庫状況を設定
    const modalTexts = document.querySelectorAll(".c-product-item-meta__modal-text");

    // 既に処理済みの要素をスキップするためのフラグ
    const processedElements = new Set();

    modalTexts.forEach((modalText) => {
      // 既に処理済みの場合はスキップ
      if (processedElements.has(modalText)) {
        return;
      }

      const productItem = modalText.closest("product-item");
      if (!productItem) {
        console.warn("product-item要素が見つかりません:", modalText);
        return;
      }

      // 商品データを取得
      const productData = this.getProductData(productItem);
      if (!productData) {
        console.warn("商品データの取得に失敗しました:", productItem);
        return;
      }

      // 商品全体の在庫状況を取得
      const stockStatus = this.getOverallStockStatus(productData);

      // テキストを更新
      modalText.textContent = stockStatus;

      // 処理済みとしてマーク
      processedElements.add(modalText);
    });
  }

  createModal() {
    // 既存のモーダルが存在するかチェック
    if (document.getElementById("c-stock-modal")) {
      this.modal = document.getElementById("c-stock-modal");
    } else {
      // モーダルHTMLを直接作成
      this.createModalHTML();
    }

    // 要素を取得
    this.overlay = this.modal.querySelector(".c-stock-modal__overlay");
    this.closeButton = this.modal.querySelector(".c-stock-modal__close");
    this.productTitle = this.modal.querySelector(".c-stock-modal__product-title");
    this.tableBody = this.modal.querySelector(".c-stock-modal__table-body");
  }

  createModalHTML() {
    const modalHTML = `
      <div id="c-stock-modal" class="c-stock-modal" style="display: none;">
        <div class="c-stock-modal__overlay"></div>
        <div class="c-stock-modal__content">
          <div class="c-stock-modal__header">
            <h3 class="c-stock-modal__title">在庫状況</h3>
            <button type="button" class="c-stock-modal__close" aria-label="閉じる">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
          <div class="c-stock-modal__body">
            <div class="c-stock-modal__product-info">
              <h4 class="c-stock-modal__product-title"></h4>
            </div>
            <div class="c-stock-modal__table-container">
              <table class="c-stock-modal__table">
                <thead>
                  <tr class="c-stock-modal__table-header">
                    <th class="c-stock-modal__table-cell c-stock-modal__table-cell--header c-stock-modal__table-cell--size-header">サイズ</th>
                  </tr>
                </thead>
                <tbody class="c-stock-modal__table-body">
                </tbody>
              </table>
            </div>
            <div class="c-stock-modal__legend">
              <div class="c-stock-modal__legend-item">
                <span class="c-stock-modal__legend-icon c-stock-modal__legend-icon--available">○</span>
                <span>在庫あり</span>
              </div>
              <div class="c-stock-modal__legend-item">
                <span class="c-stock-modal__legend-icon c-stock-modal__legend-icon--unavailable">×</span>
                <span>売り切れ</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML("beforeend", modalHTML);
    this.modal = document.getElementById("c-stock-modal");
  }

  setupEventListeners() {
    // 閉じるボタンのクリックイベント
    this.closeButton.addEventListener("click", () => {
      this.hide();
    });

    // オーバーレイのクリックイベント
    this.overlay.addEventListener("click", () => {
      this.hide();
    });

    // ESCキーのイベント
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.isVisible()) {
        this.hide();
      }
    });

    // ページネーションイベントを監視
    document.addEventListener("pagination:page-changed", () => {
      // ページネーション後の商品リスト更新を待機
      setTimeout(() => {
        this.initializeModalTexts();
      }, 100);
    });
  }

  setupColorSwatchListeners() {
    // カラースウォッチの変更イベントを監視（在庫状況テキスト更新用）
    // テキスト切り替えを無効化 - 商品全体の在庫状況を表示
    // document.addEventListener("change", (e) => {
    //   if (e.target.classList.contains("color-swatch__radio")) {
    //     this.updateModalText(e.target);
    //   }
    // });

    // モーダルテキストのクリックイベントを監視
    document.addEventListener("click", (e) => {
      if (e.target.classList.contains("c-product-item-meta__modal-text")) {
        this.handleModalTextClick(e);
      }
    });
  }

  handleModalTextClick(event) {
    const modalText = event.target;
    const productItem = modalText.closest("product-item");

    if (!productItem) {
      console.warn("product-item要素が見つかりません:", modalText);
      return;
    }

    // 商品データを取得
    const productData = this.getProductData(productItem);

    if (!productData) {
      console.warn("商品データの取得に失敗しました:", productItem);
      return;
    }

    // 条件判定: オプション数が2つでバリエーション数が1つより多い
    if (this.shouldShowModal(productData)) {
      // 現在選択されているカラーを取得
      const selectedColor = this.getSelectedColor(productItem);

      // 商品タイトルを取得
      const productTitle = modalText.dataset.productTitle || "";

      // モーダルを表示
      this.show(productData, selectedColor, productTitle);
    }
  }

  updateModalText(radio) {
    const productItem = radio.closest("product-item");
    const modalText = productItem.querySelector(".c-product-item-meta__modal-text");

    if (!modalText) {
      console.warn("モーダルテキスト要素が見つかりません:", productItem);
      return;
    }

    // 商品データを取得
    const productData = this.getProductData(productItem);

    if (!productData) {
      console.warn("商品データの取得に失敗しました:", productItem);
      return;
    }

    // 選択されたカラーの在庫状況を取得
    const selectedColor = radio.value;
    const stockStatus = this.getColorStockStatus(productData, selectedColor);

    // テキストを更新
    modalText.textContent = stockStatus;
  }

  getSelectedColor(productItem) {
    const selectedRadio = productItem.querySelector(".color-swatch__radio:checked");
    return selectedRadio ? selectedRadio.value : "";
  }

  getColorStockStatus(productData, color) {
    // カラーオプションとサイズオプションを取得
    const colorOption = productData.options.find((option) => option.name.toLowerCase().includes("color") || option.name.toLowerCase().includes("colour") || option.name.toLowerCase().includes("色"));

    const sizeOption = productData.options.find((option) => !option.name.toLowerCase().includes("color") && !option.name.toLowerCase().includes("colour") && !option.name.toLowerCase().includes("色"));

    if (!colorOption || !sizeOption) {
      return "在庫状況を確認";
    }

    // 指定されたカラーの各サイズの在庫状況をチェック
    const unavailableSizes = [];
    const availableSizes = [];

    sizeOption.values.forEach((size) => {
      const variant = this.findVariantByOptions(productData.variants, color, size);

      if (variant) {
        const inventoryQuantity = variant.inventory_quantity || 0;
        const isAvailable = inventoryQuantity > 0 || variant.available;

        if (isAvailable) {
          availableSizes.push(size);
        } else {
          unavailableSizes.push(size);
        }
      } else {
        unavailableSizes.push(size);
      }
    });

    // 在庫状況テキストを生成（新しい仕様）
    if (unavailableSizes.length === 0) {
      return "在庫あり";
    } else if (availableSizes.length === 0) {
      return "全サイズ在庫切れ";
    } else {
      return "一部在庫切れ";
    }
  }

  getProductData(productItem) {
    try {
      // productItemがDOM要素でない場合は、要素を取得
      if (typeof productItem === "string" || productItem instanceof Element) {
        // modalText要素が渡された場合、親のproduct-itemを取得
        if (productItem.classList && productItem.classList.contains("c-product-item-meta__modal-text")) {
          productItem = productItem.closest("product-item");
        }
      }

      if (!productItem || !productItem.dataset) {
        console.error("商品要素が見つかりません");
        return null;
      }

      const optionsCount = parseInt(productItem.dataset.productOptionsCount);
      const variantsCount = parseInt(productItem.dataset.productVariantsCount);
      const options = JSON.parse(productItem.dataset.productOptions);
      const variants = JSON.parse(productItem.dataset.productVariants);

      return {
        optionsCount,
        variantsCount,
        options,
        variants,
        title: productItem.querySelector(".product-item-meta__title")?.textContent?.trim() || "",
      };
    } catch (error) {
      console.error("商品データの取得に失敗しました:", error);
      return null;
    }
  }

  shouldShowModal(productData) {
    // 条件: オプション数が2つでバリエーション数が1つより多い
    return productData.optionsCount === 2 && productData.variantsCount > 1;
  }

  show(productData, selectedColor, productTitle) {
    // 商品タイトルを設定
    this.productTitle.textContent = productTitle;

    // 在庫状況テーブルを生成
    this.generateInventoryTable(productData, selectedColor);

    // モーダルを表示
    this.modal.style.display = "flex";
    document.body.style.overflow = "hidden";
  }

  hide() {
    this.modal.style.display = "none";
    document.body.style.overflow = "";
  }

  isVisible() {
    return this.modal.style.display === "flex";
  }

  generateInventoryTable(productData, selectedColor) {
    // テーブルボディをクリア
    this.tableBody.innerHTML = "";

    // カラーオプションとサイズオプションを取得
    const colorOption = productData.options.find((option) => option.name.toLowerCase().includes("color") || option.name.toLowerCase().includes("colour") || option.name.toLowerCase().includes("色"));

    const sizeOption = productData.options.find((option) => !option.name.toLowerCase().includes("color") && !option.name.toLowerCase().includes("colour") && !option.name.toLowerCase().includes("色"));

    if (!colorOption || !sizeOption) {
      this.tableBody.innerHTML = '<tr><td colspan="2" class="c-stock-modal__table-cell">商品情報が見つかりません</td></tr>';
      return;
    }

    // カラーヘッダーを生成
    this.generateColorHeaders(colorOption.values);

    // サイズ×カラーのマトリックスを生成
    this.generateMatrixRows(sizeOption.values, colorOption.values, productData.variants);
  }

  generateColorHeaders(colors) {
    const headerRow = document.querySelector(".c-stock-modal__table-header");

    // 既存のカラーヘッダーを削除（サイズヘッダー以外）
    const sizeHeader = headerRow.querySelector(".c-stock-modal__table-cell--size-header");
    headerRow.innerHTML = "";
    headerRow.appendChild(sizeHeader);

    // カラーヘッダーを追加
    colors.forEach((color) => {
      const colorHeader = document.createElement("th");
      colorHeader.className = "c-stock-modal__table-cell c-stock-modal__table-cell--header c-stock-modal__table-cell--color-header";
      colorHeader.textContent = color;
      headerRow.appendChild(colorHeader);
    });
  }

  generateMatrixRows(sizes, colors, variants) {
    sizes.forEach((size) => {
      const row = document.createElement("tr");

      // サイズセル
      const sizeCell = document.createElement("td");
      sizeCell.className = "c-stock-modal__table-cell c-stock-modal__table-cell--size-header";
      sizeCell.textContent = size;
      row.appendChild(sizeCell);

      // 各カラーの在庫状況セル
      colors.forEach((color) => {
        const variant = this.findVariantByOptions(variants, color, size);
        const statusCell = this.createStatusCell(variant);
        row.appendChild(statusCell);
      });

      this.tableBody.appendChild(row);
    });
  }

  createStatusCell(variant) {
    const cell = document.createElement("td");
    cell.className = "c-stock-modal__table-cell c-stock-modal__table-cell--status";

    if (variant) {
      const inventoryQuantity = variant.inventory_quantity || 0;

      // inventory_quantityを優先的にチェック
      if (inventoryQuantity > 0) {
        cell.textContent = "○";
        cell.classList.add("c-stock-modal__table-cell--status-available");
      } else {
        // inventory_quantityが0の場合、availableもチェック
        if (variant.available) {
          cell.textContent = "○";
          cell.classList.add("c-stock-modal__table-cell--status-available");
        } else {
          cell.textContent = "×";
          cell.classList.add("c-stock-modal__table-cell--status-unavailable");
        }
      }
    } else {
      cell.textContent = "×";
      cell.classList.add("c-stock-modal__table-cell--status-unavailable");
    }

    return cell;
  }

  findVariantByOptions(variants, color, size) {
    return variants.find((variant) => {
      const variantOptions = variant.options || [];
      return variantOptions.includes(color) && variantOptions.includes(size);
    });
  }

  getOverallStockStatus(productData) {
    // カラーオプションとサイズオプションを取得
    const colorOption = productData.options.find((option) => option.name.toLowerCase().includes("color") || option.name.toLowerCase().includes("colour") || option.name.toLowerCase().includes("色"));
    const sizeOption = productData.options.find((option) => !option.name.toLowerCase().includes("color") && !option.name.toLowerCase().includes("colour") && !option.name.toLowerCase().includes("色"));

    if (!colorOption || !sizeOption) {
      return "在庫状況を確認";
    }

    // 全バリエーションの在庫状況をチェック
    let totalVariants = 0;
    let availableVariants = 0;

    colorOption.values.forEach((color) => {
      sizeOption.values.forEach((size) => {
        const variant = this.findVariantByOptions(productData.variants, color, size);
        totalVariants++;

        if (variant) {
          const inventoryQuantity = variant.inventory_quantity || 0;
          const isAvailable = inventoryQuantity > 0 || variant.available;

          if (isAvailable) {
            availableVariants++;
          }
        }
      });
    });

    // 在庫状況テキストを生成（新しい仕様）
    if (availableVariants === totalVariants) {
      return "在庫あり";
    } else if (availableVariants === 0) {
      return "全サイズ在庫切れ";
    } else {
      return "一部在庫切れ";
    }
  }

  setupMutationObserver() {
    // DOMの変更を監視
    const observer = new MutationObserver((mutations) => {
      // ページネーションによる大量の変更を検知した場合は一括処理
      let hasProductListChanges = false;
      let newProductItems = [];

      mutations.forEach((mutation) => {
        // 新しいノードが追加された場合
        if (mutation.type === "childList") {
          mutation.addedNodes.forEach((node) => {
            // 要素ノードの場合のみ処理
            if (node.nodeType === Node.ELEMENT_NODE) {
              // product-list__innerの変更を検知
              if (node.classList && node.classList.contains("product-list__inner")) {
                hasProductListChanges = true;
                // 新しく追加されたproduct-item要素を収集
                const items = node.querySelectorAll(".product-item");
                newProductItems.push(...Array.from(items));
              } else if (node.querySelectorAll) {
                // 新しく追加されたproduct-item要素をチェック
                const items = node.querySelectorAll(".product-item");
                if (items.length > 0) {
                  newProductItems.push(...Array.from(items));
                }
              }
            }
          });
        }
      });

      // 商品リストの変更があった場合、一括で処理
      if (hasProductListChanges || newProductItems.length > 0) {
        // 重複を除去
        const uniqueProductItems = [...new Set(newProductItems)];

        // 一括で在庫状況テキストを初期化
        this.initializeProductItemsModalTexts(uniqueProductItems);
      }
    });

    // ドキュメント全体を監視
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  initializeProductItemsModalTexts(productItems) {
    // バッチ処理でパフォーマンスを改善
    const batchSize = 10;
    const processBatch = (items, startIndex) => {
      const endIndex = Math.min(startIndex + batchSize, items.length);
      const batch = items.slice(startIndex, endIndex);

      batch.forEach((productItem) => {
        this.initializeProductItemModalText(productItem);
      });

      // 次のバッチがある場合は非同期で処理
      if (endIndex < items.length) {
        requestAnimationFrame(() => {
          processBatch(items, endIndex);
        });
      }
    };

    if (productItems.length > 0) {
      processBatch(productItems, 0);
    }
  }

  initializeProductItemModalText(productItem) {
    const modalText = productItem.querySelector(".c-product-item-meta__modal-text");
    if (!modalText) return;

    // 商品データを取得
    const productData = this.getProductData(productItem);
    if (!productData) return;

    // 商品全体の在庫状況を取得
    const stockStatus = this.getOverallStockStatus(productData);

    // テキストを更新
    modalText.textContent = stockStatus;
  }
}

// 在庫管理モーダルを初期化
document.addEventListener("DOMContentLoaded", () => {
  new CStockModal();
});

// custom
// LOOKギャラリー：各LOOK内の左メイン固定＋右サブ切替
(function () {
  function initCustomLook(root = document) {
    if (!root || !root.querySelectorAll) return;

    root.querySelectorAll("[data-custom-look]:not([data-look-built])").forEach((look) => {
      const thumbs = Array.from(look.querySelectorAll("[data-look-thumb]"));
      const slides = Array.from(look.querySelectorAll("[data-look-slide]"));
      const prevButton = look.querySelector("[data-look-prev]");
      const nextButton = look.querySelector("[data-look-next]");

      if (!slides.length) return;

      const activate = (idx) => {
        const normalizedIdx = ((Number(idx) % slides.length) + slides.length) % slides.length;

        slides.forEach((slide) => {
          const on = slide.dataset.lookSlide === String(normalizedIdx);
          slide.classList.toggle("is-active", on);
          slide.hidden = !on;
        });

        thumbs.forEach((thumb) => {
          const on = thumb.dataset.lookThumb === String(normalizedIdx);
          thumb.classList.toggle("is-active", on);
          thumb.setAttribute("aria-selected", on ? "true" : "false");
        });
      };

      const getCurrentIndex = () => {
        const activeSlide = look.querySelector("[data-look-slide].is-active");
        return activeSlide ? Number(activeSlide.dataset.lookSlide) : 0;
      };

      thumbs.forEach((thumb) => {
        thumb.addEventListener("click", () => activate(thumb.dataset.lookThumb));
      });

      prevButton?.addEventListener("click", () => activate(getCurrentIndex() - 1));
      nextButton?.addEventListener("click", () => activate(getCurrentIndex() + 1));

      look.setAttribute("data-look-built", "");
    });
  }

  document.addEventListener("DOMContentLoaded", () => initCustomLook());
  document.addEventListener("shopify:section:load", (event) => initCustomLook(event.target));
})();

// custom
// カラム画像ギャラリー：各ブロック内の画像スライダー
(function () {
  function initCustomColumnGallery(root = document) {
    if (!root || !root.querySelectorAll) return;

    root.querySelectorAll("[data-column-gallery-slider]:not([data-column-gallery-built])").forEach((slider) => {
      const slides = Array.from(slider.querySelectorAll("[data-column-gallery-slide]"));
      const dots = Array.from(slider.querySelectorAll("[data-column-gallery-dot]"));
      const credits = Array.from(slider.querySelectorAll("[data-column-gallery-credit]"));
      const prevButton = slider.querySelector("[data-column-gallery-prev]");
      const nextButton = slider.querySelector("[data-column-gallery-next]");

      if (!slides.length) return;

      const activate = (idx) => {
        const normalizedIdx = ((Number(idx) % slides.length) + slides.length) % slides.length;

        slides.forEach((slide) => {
          const on = slide.dataset.columnGallerySlide === String(normalizedIdx);
          slide.classList.toggle("is-active", on);
          slide.hidden = !on;
        });

        dots.forEach((dot) => {
          const on = dot.dataset.columnGalleryDot === String(normalizedIdx);
          dot.classList.toggle("is-active", on);
          dot.setAttribute("aria-selected", on ? "true" : "false");
        });

        credits.forEach((credit) => {
          credit.hidden = credit.dataset.columnGalleryCredit !== String(normalizedIdx);
        });
      };

      const getCurrentIndex = () => {
        const activeSlide = slider.querySelector("[data-column-gallery-slide].is-active");
        return activeSlide ? Number(activeSlide.dataset.columnGallerySlide) : 0;
      };

      dots.forEach((dot) => {
        dot.addEventListener("click", () => activate(dot.dataset.columnGalleryDot));
      });

      prevButton?.addEventListener("click", () => activate(getCurrentIndex() - 1));
      nextButton?.addEventListener("click", () => activate(getCurrentIndex() + 1));

      slider.setAttribute("data-column-gallery-built", "");
    });
  }

  document.addEventListener("DOMContentLoaded", () => initCustomColumnGallery());
  document.addEventListener("shopify:section:load", (event) => initCustomColumnGallery(event.target));
})();
